var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6483 121C93.8673 121 120.797 94.1197 120.797 60.9606C120.797 27.8016 93.8673 0.920898 60.6483 0.920898C27.4293 0.920898 0.5 27.8016 0.5 60.9606C0.5 94.1197 27.4293 121 60.6483 121Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6485 108.992C87.2237 108.992 108.767 87.4877 108.767 60.9605C108.767 34.4333 87.2237 12.9287 60.6485 12.9287C34.0732 12.9287 12.5298 34.4333 12.5298 60.9605C12.5298 87.4877 34.0732 108.992 60.6485 108.992Z",
    fill: "#002D70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6481 96.9842C80.5795 96.9842 96.7371 80.8558 96.7371 60.9604C96.7371 41.0649 80.5795 24.9365 60.6481 24.9365C40.7167 24.9365 24.5591 41.0649 24.5591 60.9604C24.5591 80.8558 40.7167 96.9842 60.6481 96.9842Z",
    fill: "#116EEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6482 84.9761C73.9358 84.9761 84.7075 74.2238 84.7075 60.9602C84.7075 47.6966 73.9358 36.9443 60.6482 36.9443C47.3606 36.9443 36.5889 47.6966 36.5889 60.9602C36.5889 74.2238 47.3606 84.9761 60.6482 84.9761Z",
    fill: "#E81111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6483 72.968C67.2921 72.968 72.678 67.5919 72.678 60.9601C72.678 54.3283 67.2921 48.9521 60.6483 48.9521C54.0045 48.9521 48.6187 54.3283 48.6187 60.9601C48.6187 67.5919 54.0045 72.968 60.6483 72.968Z",
    fill: "#FFE333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalTarget);
export default __webpack_public_path__ + "static/media/GoalTarget.e55113d0187f3468fb189cde2f9c0c80.svg";
export { ForwardRef as ReactComponent };